module.exports = __webpack_public_path__ + "img/logo.5839db4c.svg";